module.exports = __webpack_public_path__ + "static/media/n07.2e4d849f.jpg";